import { Outlet, useLocation } from 'react-router-dom';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const TransitTransactions = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.TRANSIT_TRANSACTIONS && <BackButton />}
      <Outlet />
    </section>
  );
};

export default TransitTransactions;
